import React from 'react';
import { ActionPrompt } from '../../game/presentation';

const ActionBanner: React.FC<{ prompt: ActionPrompt }> = ({ prompt }) => (
  <div className={`ss-banner is-${prompt.tone}`} role="status" aria-live="polite">
    {prompt.tone === 'you' ? <span className="ss-banner-live">Your turn</span> : null}
    {prompt.tone === 'wait' ? <span className="ss-banner-wait">Waiting</span> : null}
    <h2>{prompt.headline}</h2>
    <p>{prompt.detail}</p>
  </div>
);

export default ActionBanner;
